"use client";

import React from "react";

const WhatCausesDiscoloration: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          What Causes Tooth Discoloration?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Staining falls into two categories: extrinsic and intrinsic. Knowing
          which type you have helps determine the right whitening approach.
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Food and beverages:</strong> Coffee, tea, red wine, and cola
            deposit staining compounds on enamel over time.
          </li>
          <li>
            <strong>Tobacco use:</strong> Tar and nicotine penetrate enamel,
            creating stubborn yellow or brown stains.
          </li>
          <li>
            <strong>Aging:</strong> Enamel thins naturally, revealing the
            yellowish dentin beneath.
          </li>
          <li>
            <strong>Genetics:</strong> Thinner enamel allows more dentin to show
            through.
          </li>
          <li>
            <strong>Poor oral hygiene:</strong> Plaque and tartar buildup lead
            to yellow or brown surface staining.
          </li>
          <li>
            <strong>Tooth trauma:</strong> Internal bleeding within the dentin
            can cause gray or brown discoloration.
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Extrinsic stains respond well to whitening. Intrinsic stains &mdash;
          embedded in the tooth structure &mdash; may need more advanced
          treatment or repeated sessions.
        </p>
      </div>
    </section>
  );
};

export default WhatCausesDiscoloration;
